/**
 * Load environment variables for browser/client-side use
 * Similar pattern to api-server.js loadEnv, but uses Vite's import.meta.env
 */
export function loadEnv() {
    // In browser context, Vite injects environment variables at build time
    // Access them via import.meta.env
    // Default to production API, override with env var for local development
    return {
        VITE_API_BASE: import.meta.env.VITE_API_BASE || 'https://api.pkmng.orly.io/api',
    };
}

// Load env vars (similar to api-server.js pattern)
export const env = loadEnv();
